"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ActionModal;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop2 = _interopRequireDefault(require("lodash/noop"));

var _transformers = require("../../../utils/transformers");

var _atoms = require("../../atoms");

var _Modal = _interopRequireWildcard(require("../Modal"));

var _excluded = ["title", "icon", "id", "message", "subMessage", "onClickSubMessage", "modalType", "onClose", "onAction", "actionLabel", "closeLabel", "textBold", "code"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ActionModal(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? '' : _ref$id,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? '' : _ref$message,
      _ref$subMessage = _ref.subMessage,
      subMessage = _ref$subMessage === void 0 ? '' : _ref$subMessage,
      _ref$onClickSubMessag = _ref.onClickSubMessage,
      onClickSubMessage = _ref$onClickSubMessag === void 0 ? _noop2.default : _ref$onClickSubMessag,
      _ref$modalType = _ref.modalType,
      modalType = _ref$modalType === void 0 ? 'action' : _ref$modalType,
      onClose = _ref.onClose,
      onAction = _ref.onAction,
      _ref$actionLabel = _ref.actionLabel,
      actionLabel = _ref$actionLabel === void 0 ? 'Aceptar' : _ref$actionLabel,
      _ref$closeLabel = _ref.closeLabel,
      closeLabel = _ref$closeLabel === void 0 ? 'Cancelar' : _ref$closeLabel,
      _ref$textBold = _ref.textBold,
      textBold = _ref$textBold === void 0 ? [] : _ref$textBold,
      code = _ref.code,
      modalProps = _objectWithoutProperties(_ref, _excluded);

  var header = /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col justify-center items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-28 text-center m-8"
  }, icon), /*#__PURE__*/_react.default.createElement("h5", {
    className: "uppercase font-extrabold text-center text-2xl mb-1",
    id: "".concat(id, "-label")
  }, title));

  var footer = /*#__PURE__*/_react.default.createElement("div", {
    className: "container mt-4"
  }, (modalType === 'action' || !modalType) && /*#__PURE__*/_react.default.createElement("div", {
    className: "grid grid-cols-2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pr-4"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Button, {
    block: true,
    outline: true,
    onClick: onClose
  }, closeLabel)), /*#__PURE__*/_react.default.createElement("div", {
    className: "pl-4"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Button, {
    block: true,
    onClick: onAction
  }, actionLabel))), modalType === 'inverted' && /*#__PURE__*/_react.default.createElement("div", {
    className: "grid grid-cols-2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pr-4"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Button, {
    block: true,
    onClick: onAction
  }, actionLabel)), /*#__PURE__*/_react.default.createElement("div", {
    className: "pl-4"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Button, {
    block: true,
    outline: true,
    onClick: onClose
  }, closeLabel))), modalType === 'confirmation' && /*#__PURE__*/_react.default.createElement("div", {
    className: "grid grid-cols-1"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Button, {
    onClick: onAction,
    className: "px-16 m-auto"
  }, actionLabel)));

  return /*#__PURE__*/_react.default.createElement(_Modal.default, _extends({
    className: "border-0 p-10",
    header: header,
    footer: footer,
    onClose: onClose
  }, modalProps), textBold ? /*#__PURE__*/_react.default.createElement("p", {
    className: "text-center" // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: (0, _transformers.makeBold)({
        section: message,
        keyword: '',
        withBr: textBold
      })
    }
  }) : /*#__PURE__*/_react.default.createElement("p", {
    className: "text-center"
  }, message), subMessage && /*#__PURE__*/_react.default.createElement("div", {
    className: "grid grid-cols-1 place-content-center"
  }, /*#__PURE__*/_react.default.createElement(_atoms.ActionLink, {
    onClick: onClickSubMessage,
    className: "text-center"
  }, subMessage)), /*#__PURE__*/_react.default.createElement("p", {
    className: "text-center font-bold text-xs text-subtitle"
  }, code));
}

ActionModal.propTypes = _objectSpread(_objectSpread({}, _Modal.modalPropTypes), {}, {
  title: _propTypes.default.string,
  icon: _propTypes.default.node,
  code: _propTypes.default.any,
  message: _propTypes.default.string,
  subMessage: _propTypes.default.string,
  onClickSubMessage: _propTypes.default.func,
  modalType: _propTypes.default.string,
  onClose: _propTypes.default.func,
  onAction: _propTypes.default.func,
  actionLabel: _propTypes.default.string,
  closeLabel: _propTypes.default.string,
  textBold: _propTypes.default.arrayOf(_propTypes.default.string)
});